import { Alert } from "antd";
import React from "react";

const TechnicalErrorFallback = ({ productName }: any) => (
  <Alert
    message={`We're sorry for the inconvenience. A technical issue has been identified in ${productName}, and our team is actively working on a fix. This issue will be resolved in an upcoming release.`}
    type="warning"
    showIcon
    closable
  />
);

export default TechnicalErrorFallback;
